import { Done } from "@assets/Icons";
import styles from "./styles.module.scss";

export const Stepper = ({isWalky}) => {
  return (
    <div className={styles.progressBarContainer}>
      <div className={styles.progressBar}>
        <div>
          <div className={`${styles.circle} ${isWalky ? styles.completedWalky : styles.completed}`}>
            <Done />
          </div>
        </div>
        <div className={isWalky ? styles.progressBarSegmentWalky : styles.progressBarSegment} />
        <div className={`${styles.circle} ${isWalky ? styles.currentWalky : styles.current}`}>2</div>
        <div className={isWalky ? styles.progressBarSegmentWalky : styles.progressBarSegment} />
        <div className={`${styles.circle} `}>3</div>
      </div>
      <div className={styles.stepsTitles}>
        <p>Buy plan</p>
        <p>
          <strong>Add offer</strong>
        </p>
        <p>
          <span>Access plan</span>
        </p>
      </div>
    </div>
  );
};
